<p-orderList [value]="newsBanners" [dragdrop]="true" (onReorder)="onReorder()">
  <ng-template let-newsBanner pTemplate="item">
    <div class="news-banner">
      <div class="position-circle">
        <span> {{ newsBanner.position }} </span>
      </div>
      <span class="title"> {{ newsBanner.title }} </span>
    </div>
  </ng-template>
</p-orderList>
